import * as C from "../constants";

import {
    get_users, post_user, put_user, del_user, get_roles, get_uesrs_organizations, get_notifications
} from "utils/http";
import { parseJSON } from "utils/misc";

import { logout } from "./auth";
import { history } from "../history";

export function getUsersRequest() {
    return {
        type: C.GET_USERS_REQUEST,
    }
}

export function getUsersFailure() {
    return {
        type: C.GET_USERS_FAILURE
    }
}

export function getUsersSuccess(data) {
    return {
        type: C.GET_USERS_SUCCESS,
        payload: data,
    }
}

export function createUserSuccess(user) {
    return {
        type: C.CREATE_USER,
        payload: user,
    }
}

export function createUserFailure() {
    return {
        type: C.CREATE_USER_FAILURE,
    }
}

export function editUserSuccess(user) {
    return {
        type: C.EDIT_USER,
        payload: user,
    }
}

export function editUserFailure() {
    return {
        type: C.EDIT_USER_FAILURE
    }
}

export function delUserSuccess(user) {
    return {
        type: C.DEL_USER,
        payload: user,
    }
}

export function delUserFailure() {
    return {
        type: C.DEL_USER_FAILURE,
    }
}

export function getRolesRequest() {
    return {
        type: C.GET_ROLES_REQUEST,
    }
}

export function getRolesFailure() {
    return {
        type: C.GET_ROLES_FAILURE,

    }
}

export function getRolesSuccess(roles) {
    return {
        type: C.GET_ROLES_SUCCESS,
        payload: roles,
    }
}

export function getUsersOrganizationsRequest() {
    return {
        type: C.GET_USERS_ORGANIZATIONS_REQUEST
    }
}

export function getUsersOrganizationsFailure() {
    return {
        type: C.GET_USERS_ORGANIZATIONS_FAILURE
    }
}

export function getUsersOrganizationsSuccess(data) {
    return {
        type: C.GET_USERS_ORGANIZATIONS_SUCCESS,
        payload: data,
    }
}

export function getNotificationsRequest() {
    return {
        type: C.GET_NOTIFICATIONS_REQUEST,
    }
}

export function getNotificationFailure() {
    return {
        type: C.GET_NOTIFICATIONS_FAILURE,
    }
}

export function getNotificationSuccess(data) {
    return {
        type: C.GET_NOTIFICATIONS_SUCCESS,
        payload: data,
    }
}

export function getUsers(token, page, rows_per_page) {
    return function (dispatch) {
        dispatch(getUsersRequest());
        return get_users(token, page, rows_per_page)
            .then(parseJSON).then(response => {
                dispatch(getUsersSuccess(response))
            }).catch(error => {
            dispatch(getUsersFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function createUser(token, user) {
    return function (dispatch) {
        user.email = user.email === "" ? null : user.email;
        user.name = user.name === "" ? null : user.name; 
        return post_user(token, user)
            .then(parseJSON).then(response => {
                dispatch(createUserSuccess(response));
                return response;
            }).catch(error => {
                dispatch(createUserFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
            }})

    }
}

export function editUser(token, user) {
    return function (dispatch) {
        return put_user(token, user)
            .then(parseJSON).then(response => {
                dispatch(editUserSuccess(response));
                return response;
            }).catch(error => {
                dispatch(editUserFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
            }})
    }
}

export function delUser(token, user) {
    return function (dispatch) {
        return del_user(token, user)
            .then(parseJSON).then(response => {
                dispatch(delUserSuccess(user));
                return response;
            }).catch(error => {
                dispatch(delUserFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
            }})
    }
}

export function getRoles(token) {
    return function (dispatch) {
        dispatch(getRolesRequest());
        return get_roles(token)
            .then(parseJSON).then(response => {
                dispatch(getRolesSuccess(response))
            }).catch(error => {
                dispatch(getRolesFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }})
    }
}

export function getUsersOrganizations(token) {
    return function (dispatch) {
        dispatch(getUsersOrganizationsRequest());
        return get_uesrs_organizations(token)
            .then(parseJSON).then(response => {
                dispatch(getUsersOrganizationsSuccess(response))
            }).catch(error => {
                dispatch(getUsersOrganizationsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getNotification(token) {
    return function (dispatch) {
        dispatch(getNotificationsRequest());
        return get_notifications(token)
            .then(parseJSON).then(response => {
                dispatch(getNotificationSuccess(response))
            }).catch(error => {
                dispatch(getNotificationFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }

}


// WEBPACK FOOTER //
// ./src/actions/users.js